import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Mathway = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2a1 1 0 0 0-1 1v38a1 1 0 0 0 1 1h11.42a1 1 0 0 0 .868-.504L22 31.5l5.712 9.996a1 1 0 0 0 .868.504H40a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H28.58a1 1 0 0 0-.868.504L22 12.5l-5.712-9.996A1 1 0 0 0 15.42 2H4Zm28 20v-7l-4 7 4 7v-7Zm-5.448 1h-9.104l-6.482 11.75-.483.875-.06.109c-.113.204-.423.124-.423-.109V23H5v17h10.103L22 27.5 28.897 40H39V23h-5v12.625c0 .233-.31.313-.423.109l-.06-.109-.483-.875L26.553 23ZM12 23v-8l4 7-4 7v-6Zm14.552-2 6.483-11.75.482-.875.06-.109c.113-.204.423-.124.423.109V21h5V4H29c-.034 0-.068-.002-.1-.005L22 16.5 15.1 3.995A1.012 1.012 0 0 1 15 4H5v17h5V8.375c0-.233.31-.313.423-.109l.06.109.482.875L17.448 21h9.104Z"
  }));
});
Mathway.displayName = 'Mathway';
Mathway.defaultProps = {
  'aria-label': 'Mathway'
};
export default Mathway;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Mathway.js
// module id = 3832
// module chunks = 11